// Questo script si attiverà solo se la pagina contiene il form di reset password.
const resetForm = document.getElementById('reset_password_enter_email_form');
const { authService } = await import('/assets/js/api/AuthService.js');

if (resetForm) {
    // Importiamo il servizio solo se necessario.

    const submitButton = resetForm.querySelector('#submitButton');
    const setMailDiv = document.getElementById('setMail');
    const checkMailDiv = document.getElementById('checkMail');
    const userEmailSpan = checkMailDiv.querySelector('a'); // Il link dove mostrare l'email

    // Creiamo un div per i messaggi di errore, se non esiste.
    let messageDiv = resetForm.querySelector('.error-message');
    if (!messageDiv) {
        messageDiv = document.createElement('div');
        messageDiv.className = 'mt-4 text-center text-sm font-medium';
        messageDiv.style.color = 'red';
        resetForm.appendChild(messageDiv);
    }

    resetForm.addEventListener('submit', async (e) => {
        e.preventDefault();

        // 1. Fornisci feedback visivo all'utente
        submitButton.disabled = true;
        submitButton.innerHTML = `
        <span class="kt-spinner kt-spinner-sm kt-spinner-light me-2"></span>
        Invio in corso...
      `;
        messageDiv.textContent = '';

        const emailInput = resetForm.querySelector('input[type="text"]');
        const email = emailInput.value;

        try {
            // 2. Chiama il servizio per inviare la richiesta
            await authService.forgotPassword(email);

            // 3. Se la chiamata ha successo, aggiorna l'interfaccia
            userEmailSpan.textContent = email; // Mostra l'email a cui è stato inviato il link
            setMailDiv.style.display = 'none';
            checkMailDiv.style.display = 'flex';

        } catch (error) {
            // 4. Se c'è un errore, mostralo all'utente
            messageDiv.textContent = error.message || 'Si è verificato un errore. Riprova.';

            // E ripristina il pulsante
            submitButton.disabled = false;
            submitButton.innerHTML = `
          Continua
          <i class="ki-filled ki-black-right"></i>
        `;
        }
    });
}


// Questo script si attiverà solo se la pagina contiene il form di cambio password.
const changePassForm = document.getElementById('change_password_form');

if (changePassForm) {
    const tokenInput = document.getElementById('reset_token');
    const newPasswordInput = document.getElementById('new_password');
    const confirmPasswordInput = document.getElementById('confirm_password');
    const submitButton = document.getElementById('submitButton');
    const messageDiv = document.getElementById('message');

    // Elementi per il password meter
    const passwordStrengthBar = document.getElementById('password_strength_bar');
    const passwordStrengthText = document.getElementById('password_strength_text');

    // 1. Estrai il token dall'URL e popola il campo nascosto
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get('token');

    if (token) {
        tokenInput.value = token;
    } else {
        messageDiv.style.color = 'red';
        messageDiv.textContent = 'Token di reset non valido o mancante.';
        submitButton.disabled = true;
    }

    // Funzione per calcolare la forza della password
    function checkPasswordStrength(password) {
        let score = 0;

        // Criteri di forza
        if (password.length >= 8) score++;
        if (password.length >= 12) score++;
        if (/[a-z]/.test(password)) score++;
        if (/[A-Z]/.test(password)) score++;
        if (/[0-9]/.test(password)) score++;
        if (/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(password)) score++;

        let strength = '';
        let barColor = '#ccc'; // Grigio di default
        let barWidth = '0%';

        if (password.length === 0) {
            strength = '';
            barColor = '#ccc';
            barWidth = '0%';
        } else if (score <= 2) {
            strength = 'Nuova password molto Debole';
            barColor = '#ef4444'; // Rosso
            barWidth = '25%';
        } else if (score === 3) {
            strength = 'Nuova password debole';
            barColor = '#f97316'; // Arancione
            barWidth = '50%';
        } else if (score <= 4) {
            strength = 'Nuova password media';
            barColor = '#facc15'; // Giallo
            barWidth = '75%';
        } else if (score >= 5) {
            strength = 'Nuova password forte';
            barColor = '#22c55e'; // Verde
            barWidth = '100%';
        }

        passwordStrengthBar.style.width = barWidth;
        passwordStrengthBar.style.backgroundColor = barColor;
        passwordStrengthText.textContent = strength;
        passwordStrengthText.style.color = barColor;

        return {score};
    }

    // Aggiungi un listener per l'input sul campo nuova password
    newPasswordInput.addEventListener('input', () => {
        const password = newPasswordInput.value;
        checkPasswordStrength(password);
    });

    changePassForm.addEventListener('submit', async (e) => {
        e.preventDefault();
        if (!token) return;

        const originalButtonText = submitButton.innerHTML;

        // 2. Feedback visivo: disabilita il pulsante e mostra lo spinner
        submitButton.disabled = true;
        submitButton.innerHTML = `<span class="kt-spinner kt-spinner-sm kt-spinner-light me-2"></span> Salvataggio...`;
        messageDiv.textContent = '';

        const newPassword = newPasswordInput.value;
        const confirmPassword = confirmPasswordInput.value;

        // --- INIZIO MIGLIORAMENTO ---
        // Funzione helper per gestire gli errori di validazione e riattivare il pulsante
        const handleValidationError = (message) => {
            messageDiv.style.color = 'red';
            messageDiv.textContent = message;
            submitButton.disabled = false;
            submitButton.innerHTML = originalButtonText;
        };

        // Validazione lato client
        if (newPassword.length < 8) {
            return handleValidationError('La password deve essere di almeno 8 caratteri.');
        }
        if (newPassword !== confirmPassword) {
            return handleValidationError('Le password non corrispondono.');
        }
        const {score} = checkPasswordStrength(newPassword);
        if (score < 3) {
            return handleValidationError('La password è troppo debole. Scegline una più complessa.');
        }
        // --- FINE MIGLIORAMENTO ---

        try {
            // 3. Chiama il servizio API
            const response = await authService.resetPassword(token, newPassword, confirmPassword);

            // 4. Gestisci il successo
            messageDiv.style.color = 'green';
            // --- MODIFICA QUI ---
            // La risposta ora è incapsulata in response.data
            messageDiv.textContent = response.data.message || 'Password aggiornata con successo! Sarai reindirizzato al login.';

            // Reindirizza al login dopo qualche secondo
            setTimeout(() => {
                window.location.href = '/login';
            }, 2000);


        } catch (error) {
            // 5. Gestisci l'errore API
            messageDiv.style.color = 'red';
            messageDiv.textContent = error.message || 'Si è verificato un errore. Riprova.';

            // Riattiva il pulsante in caso di errore
            submitButton.disabled = false;
            submitButton.innerHTML = originalButtonText;
        }
    });
}

